import { formatDate } from "../../../services/localeFormat";
import React from "react";
import Meta from "../Meta";
import PageHeader from "../components/PageHeader";
import Loader from "../loader";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { resolveImage } from "../utils";

const styles = `
.t26-article {
  padding: 0 clamp(16px, 4vw, 32px) clamp(40px, 6vw, 80px);
  max-width: 820px;
  margin-inline: auto;
}
.t26-article__lead {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: clamp(18px, 2vw, 24px);
  object-fit: cover;
  margin-bottom: 24px;
  box-shadow: var(--shadow-md);
}
.t26-article__meta {
  display: flex; gap: 14px; flex-wrap: wrap;
  font-size: 13px;
  color: var(--ink-3);
  margin-bottom: 14px;
}
.t26-article__meta a { color: var(--primary); text-decoration: none; }
.t26-article__meta a:hover { text-decoration: underline; }
.t26-article__content {
  font-size: 17px; line-height: 1.75;
  color: var(--ink-2);
}
.t26-article__content h2, .t26-article__content h3 {
  font-family: var(--font-display); color: var(--ink); margin: 28px 0 12px;
}
.t26-article__content p { margin: 0 0 14px; }
.t26-article__content img { max-width: 100%; height: auto; border-radius: var(--r-md); }
.t26-article__content a { color: var(--primary); text-decoration: underline; }
`;

export default function Article({ context, loading }) {
    const { org, data } = context;

    if (loading) {
        return (
            <>
                <Meta context={context} title={t`Article`} />
                <Loader />
            </>
        );
    }

    if (!data || data.length === 0) {
        return (
            <>
                <Meta context={context} title={t`Article introuvable`} noindex />
                <div style={{ padding: 60, textAlign: "center", color: "var(--ink-3)" }}>
                    <Trans>Cet article n'a pas été trouvé.</Trans>
                </div>
            </>
        );
    }

    const item = data[0];
    const title = item.title;
    const description = item.description;
    const image = item.image ? resolveImage(item.image) : null;
    const credit = Array.isArray(item.credits) && item.credits.length > 0 ? item.credits[0] : null;

    return (
        <>
            <Meta context={context} title={title} description={description} image={image} />
            <style dangerouslySetInnerHTML={{ __html: styles }} />

            <PageHeader
                title={title}
                subtitle={description}
                crumbs={[
                    { label: t`Accueil`, url: org.BASE_WEB_URL },
                    { label: t`Actualités`, url: org.BASE_WEB_URL + "/actualites" },
                    { label: title },
                ]}
            />

            <article className="t26-article">
                {image && <img src={image} alt={title} className="t26-article__lead" />}

                <div className="t26-article__meta">
                    {credit && (
                        <span>
                            <Trans>Par</Trans> <a href={credit.link} target="_blank" rel="noopener noreferrer">{credit.name}</a>
                        </span>
                    )}
                    {item.datetime && <span>{formatDate(item.datetime, context.langValue, "DD MMM YYYY")}</span>}
                </div>

                {item.content && (
                    <div className="t26-article__content" dangerouslySetInnerHTML={{ __html: item.content }} />
                )}
            </article>
        </>
    );
}
